const updateCampaign = (campaign_data) => ({
    type: 'UPDATE_CAMPAIGN',
    id: 1,
    campaign_data: campaign_data
})

export { updateCampaign }
